var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightTriangle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4316 6.63867L1.30664 1.01338C1.1877 0.962402 1.06231 0.911133 0.938087 0.911133C0.68546 0.911133 0.43711 1.01364 0.255469 1.20557C-0.014598 1.51787 -0.076845 1.94238 0.0989362 2.29424L2.8125 7.5L0.0990241 12.7061C-0.0767571 13.0582 -0.0145013 13.4824 0.255587 13.7687C0.436876 13.9605 0.685079 14.0631 0.937618 14.0631C1.06213 14.0631 1.18755 14.0384 1.30647 13.9871L14.4316 8.36133C14.7768 8.21394 15.0003 7.87471 15.0003 7.49971C14.9736 7.125 14.7773 6.78516 14.4316 6.63867ZM0.936915 1.87588C0.937208 1.87529 0.936329 1.87617 0.936915 1.87588L12.9697 7.03125H3.62402L0.936915 1.87588ZM0.930176 13.1396L3.62402 7.96875H12.9434L0.930176 13.1396Z",
    fill: "#363636"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightTriangle);
export default __webpack_public_path__ + "static/media/rightTriangle.580e66639ad9b0f1eaee67bc168b75f0.svg";
export { ForwardRef as ReactComponent };